<div class="welcome-section">
    <div class="welcome-greeting">
        <i class="fas {{ greetingIcon() }} welcome-icon"></i>
        <span class="greeting-text">{{ greeting() }} {{ firstName() }}</span>
    </div>
    <div class="welcome-actions">
        <div class="pillbox-wrapper" (click)="openKompassen()">
            <rask-pillbox text="Kompassen">
                <i class="fas fa-external-link-alt ms-1"></i>
            </rask-pillbox>
        </div>
    </div>
</div>